import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, AppState } from '@nextgen-web-framework/core';
import { updateResendClockData } from '@commerce-identity-webcomponents/sdk';
import { workerCode } from './timerWorker';

const useTimer = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { secondsLeft } = useSelector((state: AppState) => state.commerceIdentity.resendClockData);
  const workerRef = useRef<Worker | null>(null);
  useEffect(() => {
    if (secondsLeft <= 0) {
      return undefined;
    }
    if (!workerRef.current) {
      const code = workerCode.toString();
      const blob = new Blob([`(${code})()`], { type: 'application/javascript' });
      workerRef.current = new Worker(URL.createObjectURL(blob));

      workerRef.current.onmessage = (e) => {
        const { secondsLeft: newSecondsLeft } = e.data;

        if (newSecondsLeft >= 0) {
          dispatch(
            updateResendClockData({
              secondsLeft: newSecondsLeft,
            }),
          );
        }
      };
    }
    workerRef.current.postMessage({ secondsLeft });
    return () => {
      if (workerRef.current) {
        workerRef.current.terminate();
        workerRef.current = null;
      }
    };
  }, [secondsLeft]);

  return [secondsLeft] as const;
};

export default useTimer;
